// extracted by mini-css-extract-plugin
export default {"title":"Gachapon-Text_title__++ZbB","text":"Gachapon-Text_text__ObZO2","dark":"Gachapon-Text_dark__wOF-o"};